export default {
  text: '{{threshold}} de vendas mensais: {{amount}}',
  label: '{{threshold}} de vendas mensais:',
  no_discount: 'sem desconto',
  discount_badge: '-{{percentage}}%',
};
